export const getTailwindColor = (color: string) => {
    switch (color) {
        case "#CCFF50":
            return "bg-brand-yellow";
        case "#5AD7FF":
            return "bg-brand-blue";
        case "#FF2A00":
            return "bg-brand-red";
        case "#CBC5B5":
            return "bg-brand-gray-light";
        default:
            return "bg-feed-dark text-brand-white";
    }
};
